module.exports = __webpack_public_path__ + "img/img-4.66c9e715.webp";